import { deleteTokenLocal } from '../indexeddb/cookieIdb';

const checkAuthError = (error) => {
	if (error?.response?.status === 401) {
		// We use deleteTokenLocal() here and in App.js we
		// listen for idb changes and trigger the logout there if the token gets deleted
		// with this: https://dexie.org/docs/dexie-react-hooks/useLiveQuery()

		deleteTokenLocal().catch((err) => console.error('checkAuthError deleteTokenLocal', err));
	}
};

export default checkAuthError;
